<template>
  <VueRecaptcha
    ref="recaptcha"
    :sitekey="this.sitekey"
    :loadRecaptchaScript="true"
    size="invisible"
    @verify="validate"
  />
</template>
<script>
import VueRecaptcha from "vue-recaptcha";
export default {
  components: { VueRecaptcha },
  data() {
    return {
      userName: "",
      userRegister: "",
      //sitekey: "6LfYG88ZAAAAAP-gDmiDBCRlPXaCs4S74UXoiEFL", //#test key
      sitekey: "6Leg2e8UAAAAAJ2aJOXwTYwKlCaQ5MNg3qVBSa8T",
      empty_key: "-111111",
    };
  },
  methods: {
    resetRecaptcha() {
      this.$refs.recaptcha.reset();
    },
    checkSubmit(userName, userRegister, isPhone) {
      if (userRegister != "") {
        this.userRegister = userRegister;
      } else {
        this.userRegister = this.empty_key;
      }
      if (userName != "") {
        this.userName = userName;
      } else {
        this.userName = this.empty_key;
      }
      this.isPhone = isPhone;
      // this.$refs.recaptcha.execute();
      this.validate();
    },
    validate(response) {
      // response="";
      // var isTest = 0;
      this.$insProgress.start();
      var type = "Phone";
      if (this.isPhone) {
        type = "Card";
      }
      this.$bonusApi
        .post(
          "auth/find/user",
          {
            userName: this.userName,
            userRegister: this.userRegister,
            type: 0,
            userNameType: type,
          },
          {
            headers: {
              "Accept-Language": "mn-MN",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.length > 0) {
              this.$emit("checkRecaptcha", response);
              this.$insProgress.finish();
            }
          } else if (response.data.status === 100) {
            this.$emit("recaptchaError", response.data.message);
            this.$insProgress.finish();
          }
          this.resetRecaptcha();
        })
        .catch((error) => {
          this.$emit("recaptchaError", error.response.data.message);
          this.$insProgress.finish();
        });
    },
  },
};
</script>
